import { FormControl, Grid, Typography } from '@mui/material';
import React from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { payRateModStyles } from './PayRateMod.styles';
import { LayoutGridItem } from 'app/layout/LayoutGrid';
import { FormInputCheckbox } from '../../../../../../Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputCheckbox';
import { useSelector } from 'react-redux';
import { selectPayRateGww } from 'store/redux-store/placement-mods/selectors';
import { FormInputDropdown } from '@AMIEWEB/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputDropdown';

export const PayRateGwwMod = ({ isExpanded, isModEdit }: { isExpanded: boolean; isModEdit: boolean }) => {
  const { t } = useTranslation();
  const { control, getValues, setValue } = useFormContext();
  const { classes } = payRateModStyles({ isExpanded });
  const handleCheckboxChange = event => {
    if (!event) {
      setValue('gwwExceptions', []);
    }
  };

  const formatDropdownOptions = (options: { id: string; description: string }[]) => {
    if (options) {
      const newOptions = options.map(item => {
        return {
          ID: item.id,
          Description: item.description,
        };
      });
      return newOptions;
    }
    return [];
  };

  const getGwwPayRate = useSelector(selectPayRateGww);
  const isGwwChecked = useWatch<boolean>({ name: 'paysGww' });

  return (
    <Grid>
      <div className={classes.labelRow} style={{ paddingLeft: '0px', paddingTop: '24px' }}>
        <Typography component="span" className={classes.headings}>{`${t(
          'placement.placementMods.guaranteedWorkWeek',
        )}`}</Typography>
      </div>
      <Grid className={classes.flex}>
        <Grid alignSelf="end">
          <Controller
            control={control}
            name={'paysGww'}
            render={({ field: { onChange, value, ...rest } }) => {
              return (
                <FormControl disabled={!isModEdit}>
                  <LayoutGridItem className={classes.labelRow} style={{ paddingTop: '0px', paddingLeft: '0px' }}>
                    <div>
                      <FormInputCheckbox
                        labelStyle={classes.checkBoxLabelGww}
                        name={`paysGww`}
                        labelClass={classes.checkBoxLabelGww}
                        isChecked={isGwwChecked}
                        checkboxLabel={`${t('placement.placementMods.paysGWW')}`}
                        isDisabled={!isModEdit}
                        handleChecked={e => {
                          onChange(e);
                          handleCheckboxChange(e);
                        }}
                      />
                    </div>
                  </LayoutGridItem>
                </FormControl>
              );
            }}
          />
        </Grid>
        <Grid>
          <Controller
            control={control}
            name={'gwwExceptions'}
            render={({ field: { onChange, value, ...rest } }) => {
              return (
                <FormInputDropdown
                  name={'gwwExceptions'}
                  label={t('placement.placementMods.exceptions')}
                  require={false}
                  multiple
                  useMenuItem
                  displayMenuTop
                  customClass={classes.gwwDropdown}
                  standard={true}
                  options={formatDropdownOptions(getGwwPayRate)}
                  inputValue={getValues('gwwExceptions') ?? []}
                  readOnly={!isModEdit || !isGwwChecked}
                  handleChange={e => {
                    onChange(e);
                  }}
                ></FormInputDropdown>
              );
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
